import i18n from 'modules/core/lib/i18n'

import { ActivationCenterStatuses } from './enums'

export const ActivationCenterPercentage: Record<number, ActivationCenterStatuses> = {
  10: ActivationCenterStatuses.LIMITED_DATA,
  20: ActivationCenterStatuses.SOME_DATA,
  40: ActivationCenterStatuses.MODERATE_DATA,
  60: ActivationCenterStatuses.EXTENSIVE_DATA,
  80: ActivationCenterStatuses.ALMOST_COMPLETED_DATA,
  100: ActivationCenterStatuses.COMPLETED_DATA,
}

export const ActivationCenterStatusesLabels = () => {
  return {
    [ActivationCenterStatuses.VERY_LOW_DATA]: i18n.t(
      'finance.financial_workspace.activation_center.statuses.very_low_data'
    ),
    [ActivationCenterStatuses.LIMITED_DATA]: i18n.t(
      'finance.financial_workspace.activation_center.statuses.limited_data'
    ),
    [ActivationCenterStatuses.SOME_DATA]: i18n.t(
      'finance.financial_workspace.activation_center.statuses.some_data'
    ),
    [ActivationCenterStatuses.MODERATE_DATA]: i18n.t(
      'finance.financial_workspace.activation_center.statuses.moderate_data'
    ),
    [ActivationCenterStatuses.EXTENSIVE_DATA]: i18n.t(
      'finance.financial_workspace.activation_center.statuses.extensive_data'
    ),
    [ActivationCenterStatuses.ALMOST_COMPLETED_DATA]: i18n.t(
      'finance.financial_workspace.activation_center.statuses.almost_completed_data'
    ),
    [ActivationCenterStatuses.COMPLETED_DATA]: i18n.t(
      'finance.financial_workspace.activation_center.statuses.completed_data'
    ),
  }
}

export const calculateStatus = (total: number, completed: number): ActivationCenterStatuses => {
  const percentage = Math.floor((completed / total) * 100)
  const ranges = Object.keys(ActivationCenterPercentage).map(Number)

  const selectedRange = ranges.reduce((a, b) => {
    return percentage >= b ? b : a
  }, ranges[0])

  return ActivationCenterPercentage[Number(selectedRange)] ?? ActivationCenterStatuses.LIMITED_DATA
}
